const isDesktop = window.matchMedia("(min-width: 768px)").matches;

const pinDesktopText = () => {
  const newsSectionContainer = document.querySelector(".news-container");

  if (!newsSectionContainer) return;
  const gridContainer = newsSectionContainer.querySelector(
    ".news-grid-container",
  );
  const title = newsSectionContainer.querySelector(".text-news-container");

  if (!isDesktop) return;
  if (!newsSectionContainer || !title) return;

  ScrollTrigger.create({
    trigger: gridContainer,
    start: "top 98px",
    end: "bottom 70%",
    pin: title,
    pinSpacing: false,
  });
};

export default pinDesktopText;
